import { ServiceClient } from 'src/utils'
import { GroupRow } from './gm_scopes'

const serviceClient = ServiceClient.singleton()

export class GroupManagerService {
    static #INSTANCE = new GroupManagerService()
    static readonly singleton = () => GroupManagerService.#INSTANCE

    async fetchGroups(nameFilter?: string, showDeleted?: boolean): Promise<GroupRow[]> {
        const data = await serviceClient.authGet<GroupRow[]>(
            `/api/group-manager?name=${nameFilter || ''}&showDeleted=${!!showDeleted}`
        )
        return data
    }

    async fetchAdministeredGroups(): Promise<GroupRow[]> {
        const data = await serviceClient.authGet<GroupRow[]>('/api/group-manager/fetchAdministeredGroups')
        return data
    }

    async fetchGroupById(groupId: number): Promise<GroupRow> {
        const data = await serviceClient.authGet<GroupRow>(`/api/group-manager/${groupId}`)
        return data
    }

    async createGroup(group: GroupRow): Promise<GroupRow> {
        const data = await serviceClient.authPost<GroupRow>('/api/group-manager', group)
        return data
    }

    async updateGroup(groupId: number, group: GroupRow): Promise<GroupRow> {
        const data = await serviceClient.authPut<GroupRow>(`/api/group-manager/${groupId}`, group)
        return data
    }

    async deleteGroup(groupId: number): Promise<void> {
        return serviceClient.authDelete(`/api/group-manager/${groupId}`)
    }

    async restoreGroup(groupId: number): Promise<void> {
        return serviceClient.authPost(`/api/group-manager/restore/${groupId}`)
    }
}

export default GroupManagerService.singleton()
